// extracted by mini-css-extract-plugin
module.exports = {"Action":"Action_Action__1ZREI"};